import { Component, inject } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { DrawerModule } from 'primeng/drawer';
import { ButtonDirective } from 'primeng/button';
import { Ripple } from 'primeng/ripple';

@Component({
    selector: 'app-profilemenu',
    templateUrl: './app.profilesidebar.component.html',
    imports: [DrawerModule, ButtonDirective, Ripple]
})
export class AppProfileSidebarComponent {
    layoutService = inject(LayoutService);


    get visible(): boolean {
        return this.layoutService.state.profileSidebarVisible;
    }

    set visible(_val: boolean) {
        this.layoutService.state.profileSidebarVisible = _val;
    }
}
